import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import styles from "./Style.module.css";
import DropDownIcon from "../../Icons/DropDownIcon";
import SearchBar from "../../Search/SearchBar";
import CrossIcon from "../../../Assets/images/cross.svg";
import { formatDateToDDMMYYYY } from "../../../Utils/utils";
import { getDiscountList } from "../../../APICalling/APICalling";
import { useGlobalContext } from "../../../Context/GlobalContext";
import logger from "../../../Utils/logger";

const DiscountDropdown = ({
	bookingItemId,
	onSelect,
	selectedLabel,
	selectedOption: externalSelectedOption,
	onDropdownToggle = null,
	serviceId,
	selectedOutletID,
	selectedServicePrice,
	selectedAddons,
	disabled = false,
}) => {
	const { selectedDate, selectedOutlet, selectedOutletData, bookingData } = useGlobalContext();
	const [selectedOption, setSelectedOption] = useState({});
	const [isDropdownOpen, setDropdownOpen] = useState(false);
	const [searchQuery, setSearchQuery] = useState("");
	const [discountList, setDiscountList] = useState([]);
	const [isLoadingDiscounts, setIsLoadingDiscounts] = useState(false);
	const dropdownRef = useRef(null);
	const dropdownMenuRef = useRef(null);
	const searchInputRef = useRef(null);
	const effectiveOutletID = [
		selectedOutletID,
		selectedOutletData?.id,
		selectedOutlet,
		bookingData?.outlet,
	].find((value) => value != null && value !== "") ?? null;

	// Sync internal state when parent clears selection (e.g. "Apply membership discount" turns on)
	useEffect(() => {
		if (!externalSelectedOption || !externalSelectedOption?.item) {
			setSelectedOption({});
		} else {
			setSelectedOption(externalSelectedOption);
		}
	}, [externalSelectedOption]);
	// Prefer external when it has a selection; otherwise internal (after sync, empty when parent cleared)
	const currentSelectedOption = externalSelectedOption?.item
		? externalSelectedOption
		: selectedOption?.item
			? selectedOption
			: {};

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target)
			) {
				setDropdownOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);


	// const fetchDiscountList = useCallback(async () => {
	// 	if (!effectiveOutletID || !serviceId) {
	// 		setDiscountList([]);
	// 		return;
	// 	}
	// 	setIsLoadingDiscounts(true);
	// 	try {
	// 		const item = {
	// 			date: formatDateToDDMMYYYY(selectedDate),
	// 			outlet_id: effectiveOutletID,
	// 			service_id: serviceId,
	// 			pagination: 1,
	// 			category: 'service'
	// 		};
	// 		const response = await getDiscountList(item);
	// 		const rawDiscountList = response?.data?.data?.list?.adjustments || [];

	// 		const addOnPrice = selectedAddons.reduce((sum, addon) => sum + parseFloat(addon.price || 0), 0);
	// 		const price = (parseFloat(servicePrice) || 0) + (parseFloat(addOnPrice) || 0);

	// 		// logger.log("discount dropdown >> price", price);
	// 		logger.log("discount dropdown >> servicePrice", servicePrice);
	// 		logger.log("discount dropdown >> addOnPrice", addOnPrice);
			
	// 		logger.log("discount dropdown >> rawDiscountList", rawDiscountList);
	// 		logger.log("discount dropdown >> selectedAddons", selectedAddons);

	// 		const updatedDiscountList = (Array.isArray(rawDiscountList) ? rawDiscountList : []).map((discount) => {
	// 			let amount;
	// 			if (discount.type === "percentage") {
	// 				const percentValue = parseFloat(discount.value || 0);
	// 				amount = (percentValue / 100) * price;
	// 			} else {
	// 				amount = parseFloat(discount.value || 0);
	// 			}
	// 			// effect: discount = negative, surcharge = positive
	// 			if (discount.effect === "discount") {
	// 				amount = -Math.abs(amount);
	// 			} else {
	// 				amount = Math.abs(amount);
	// 			}
	// 			return { ...discount, amount };
	// 		});
	// 		logger.log("discount dropdown >> updatedDiscountList", updatedDiscountList);
	// 		setDiscountList(updatedDiscountList);
	// 	} catch (error) {
	// 		console.error("Error fetching discount list:", error);
	// 		setDiscountList([]);
	// 	} finally {
	// 		setIsLoadingDiscounts(false);
	// 	}
	// }, [effectiveOutletID, serviceId, selectedDate, servicePrice]);



	// Helper to format amount for display: discount = "-", surcharge = "+"
	
	
	
	const fetchDiscountList = useCallback(async () => {
		if (!effectiveOutletID || !serviceId) {
			setDiscountList([]);
			return;
		}
	
		setIsLoadingDiscounts(true);
	
		try {
			const item = {
				date: formatDateToDDMMYYYY(selectedDate),
				outlet_id: effectiveOutletID,
				service_id: serviceId,
				pagination: 1,
				category: 'service'
			};
	
			const response = await getDiscountList(item);
	
			const rawDiscountList =
				response?.data?.data?.list?.adjustments || [];
	
			logger.log(
				"discount dropdown >> rawDiscountList",
				rawDiscountList
			);
			logger.log(
				"discount dropdown >> selectedAddons",
				selectedAddons
			);
	
			const updatedDiscountList = (
				Array.isArray(rawDiscountList)
					? rawDiscountList
					: []
			).map((discount) => {
	
				// Get addon ids on which current discount is applicable
				const discountAddonIds =
					discount?.addons?.map((addon) => addon.id) || [];
	
				// Calculate only applicable addon price
				const applicableAddonPrice = selectedAddons.reduce(
					(sum, addon) => {
						if (discountAddonIds.includes(addon.id)) {
							return (
								sum +
								(parseFloat(
									addon.addon_rate?.nonMemberPrice ||
									addon.unit_price ||
									0
								) *
									(addon.quantity || 1))
							);
						}
						return sum;
					},
					0
				);

				logger.log("discount dropdown >> selectedServicePrice", selectedServicePrice);
	
				// Service price + only applicable addon price
				const effectivePrice =
					(parseFloat(selectedServicePrice) || 0) +
					applicableAddonPrice;
	
				let amount = 0;
	
				if (discount.type === "percentage") {
					const percentValue = parseFloat(
						discount.value || 0
					);
	
					amount =
						(percentValue / 100) * effectivePrice;
				} else {
					amount = parseFloat(discount.value || 0);
				}
	
				// effect: discount = negative, surcharge = positive
				if (discount.effect === "discount") {
					amount = -Math.abs(amount);
				} else {
					amount = Math.abs(amount);
				}
	
				return {
					...discount,
					applicableAddonPrice,
					effectivePrice,
					amount
				};
			});
	
			logger.log(
				"discount dropdown >> updatedDiscountList",
				updatedDiscountList
			);
	
			setDiscountList(updatedDiscountList);
		} catch (error) {
			console.error(
				"Error fetching discount list:",
				error
			);
			setDiscountList([]);
		} finally {
			setIsLoadingDiscounts(false);
		}
	}, [
		effectiveOutletID,
		serviceId,
		selectedDate,
		selectedAddons,
		selectedServicePrice
	]);
	
	
	
	const formatAmount = (amount, effect) => {
		if (amount == null) return "$0";
		const num = Math.abs(parseFloat(amount));
		const sign = effect === "surcharge" ? "+" : effect === "discount" ? "-" : "";
		return `${sign}$${num.toFixed(2)}`;
	};

	// Filter and map discount items for display
	const filteredDiscounts = useMemo(() => {
		const list = Array.isArray(discountList) ? discountList : [];
		const q = (searchQuery || "").trim().toLowerCase();
		return list
			.filter((item) => {
				const name = (item.name || item.label || item.title || "").toString().toLowerCase();
				return !q || name.includes(q);
			})
			.map((item) => ({
				...item,
				displayName: item?.title,
				displayAmount: formatAmount(item?.amount ?? item?.value, item?.effect),
			}));
	}, [discountList, searchQuery]);



	// Focus search input when dropdown opens
	useEffect(() => {
		if (isDropdownOpen && searchInputRef.current) {
			// Small delay to ensure the dropdown is rendered
			setTimeout(() => {
				searchInputRef.current?.focus();
				searchInputRef.current?.select();
			}, 0);
		}
	}, [isDropdownOpen]);

	const handleSelect = (item) => {
		const itemWithBookingId = { ...item, bookingItemId };
		const selectedOptionData = { item: itemWithBookingId };
		setSelectedOption(selectedOptionData);
		if (onSelect) {
			onSelect(itemWithBookingId);
		}
		setDropdownOpen(false);
		setSearchQuery("");
	};

	const handleClearDiscount = (e) => {
		e.stopPropagation();
		setSelectedOption({});
		if (onSelect) {
			onSelect(null);
		}
	};	

	return (
		<div
			ref={dropdownRef}
			className={`${styles.discountDropdown} commonDropdownNoImage position-relative ${disabled ? "disabled" : ""}`}
			tabIndex={0}
			>
			<div className={`dropdownToggle ${styles.dropdownToggle}`}
				onClick={() => {
					const newState = !isDropdownOpen;
					setDropdownOpen(newState);
					if (newState) {
						fetchDiscountList();
					}
					if (onDropdownToggle) {
						onDropdownToggle(newState);
					}
				}}>
				{currentSelectedOption?.item ? (
					<div className={styles.selectedDiscount}>
						<span className={styles.selectedDiscountText}>
							{currentSelectedOption.item.title ?? currentSelectedOption.item.name ?? currentSelectedOption.item.label}
						</span>
						<button
							type="button"
							className={styles.selectedDiscountClose}
							onClick={handleClearDiscount}
							aria-label="Remove Discount">
							<img src={CrossIcon} alt="" width={10} height={10} />
						</button>
					</div>
				) : (
					<div className="hover-underline">
						+ Add Discount
					</div>
				)}
				{/* {!selectedLabel && (
					<DropDownIcon 
						size={12} 
						color="#6b7280" 
						className={`${styles.dropdownIcon} ${isDropdownOpen ? styles.rotated : ''}`}
					/>
				)} */}
		</div>
		{isDropdownOpen && (
			<div className={`${styles.dropdownContainer}`} ref={dropdownMenuRef}>
				{/* Search Bar */}
				<div className={styles.header}>
					<SearchBar
						ref={searchInputRef}
						placeholder="Search..."
						value={searchQuery}
						onChange={(e) => setSearchQuery(e.target.value)}
						// onKeyDown={handleKeyDown}
						className="border-0"
					/>
				</div>
				<div className={`${styles.dropdownMenu}`}>
					{isLoadingDiscounts ? (
						<div className={styles.loadingState}>Loading...</div>
					) : filteredDiscounts.length === 0 ? (
						<div className={styles.emptyState}>No discounts available</div>
					) : (
						<ul className={styles.bottomList}>
							{filteredDiscounts.map((item) => (
								<li
									key={item.id ?? item.displayName}
									className={`${styles.item} ${currentSelectedOption?.item?.id === item.id ? styles.selectedItem : ""}`}
									onClick={() => handleSelect(item)}>
									<span className={styles.left}>{item.displayName}</span>
									<span className={styles.discountAmount}>{item.displayAmount}</span>
								</li>
							))}
						</ul>
					)}
				</div>
			</div>
		)}
	</div>
	);
};

export default DiscountDropdown;
